import { MediaResolutionPipeline } from '../pipeline/MediaResolutionPipeline';
import { ResolverRegistry } from '../pipeline/ResolverRegistry';
import { DirectFileResolver } from '../resolvers/DirectFileResolver';
import { DirectImageResolver } from '../resolvers/DirectImageResolver';
import { GenericEmbedResolver } from '../resolvers/GenericEmbedResolver';
import { HlsResolver } from '../resolvers/HlsResolver';
import { HtmlVideoResolver } from '../resolvers/HtmlVideoResolver';
import { OEmbedResolver } from '../resolvers/OEmbedResolver';
import { OpenGraphResolver } from '../resolvers/OpenGraphResolver';
import { UnknownResolver } from '../resolvers/UnknownResolver';
import { HttpContentFetcher, HttpFetcher } from '../services/HttpContentFetcher';
import { MediaResolutionCache } from '../services/MediaResolutionCache';

export type MediaResolutionDependencies = {
  fetchImpl?: HttpFetcher;
  cacheTtlMs?: number;
};

export const createMediaResolutionContainer = (dependencies: MediaResolutionDependencies = {}) => {
  const fetcher = new HttpContentFetcher(dependencies.fetchImpl);
  const cache = new MediaResolutionCache(dependencies.cacheTtlMs);
  const registry = new ResolverRegistry();

  registry.register(new DirectImageResolver());
  registry.register(new DirectFileResolver());
  registry.register(new HlsResolver());
  registry.register(new OEmbedResolver());
  registry.register(new OpenGraphResolver());
  registry.register(new HtmlVideoResolver());
  registry.register(new GenericEmbedResolver());
  registry.register(new UnknownResolver());

  const pipeline = new MediaResolutionPipeline(registry, fetcher, cache);

  return {
    pipeline,
    registry,
    cache,
    fetcher,
  };
};

let defaultContainer: ReturnType<typeof createMediaResolutionContainer> | null = null;

export const getMediaResolutionPipeline = (): MediaResolutionPipeline => {
  if (!defaultContainer) {
    defaultContainer = createMediaResolutionContainer();
  }

  return defaultContainer.pipeline;
};

export const resetMediaResolutionContainer = (): void => {
  defaultContainer = null;
};
